
import React from 'react';
import AuditHeader from './AuditHeader';
import MessageAlert from './MessageAlert';
import SearchBar from './SearchBar';
import AuditTable from './AuditTable';
import Pagination from './Pagination';
import AuditDetailsPanel from './AuditDetailsPanel';
// import { useAuditTrail } from '../../hooks/useAuditTrail';
import styles from './AuditTrail.module.css';
import { useAuditTrail } from './Hooks/UseAuditTrial';

function AuditTrail() {
    const {
        auditLogs,
        loading,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalRecords,
        message,
        slidingPanel,
        fetchAuditDetails,
        closeSlidingPanel,
        downloadExcel
    } = useAuditTrail();

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
    };

    return (
        <div className={styles.container}>
            <AuditHeader
                onExport={downloadExcel}
                loading={loading}
            />

            <MessageAlert message={message} />

            <SearchBar
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
            />

            <div className={styles.tableWrapper}>
                <AuditTable
                    auditLogs={auditLogs}
                    loading={loading}
                    onViewDetails={fetchAuditDetails}
                />
            </div>

            <Pagination
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRecords}
                onPageChange={setCurrentPage}
                onRowsPerPageChange={handleRowsPerPageChange}
            />

            <AuditDetailsPanel
                slidingPanel={slidingPanel}
                onClose={closeSlidingPanel}
            />
        </div>
    );
}

export default AuditTrail;














